export interface HomepageVideoSources {
  videoUrl: string;
  videoPoster?: string;
  portraitVideoUrl?: string;
  portraitVideoPoster?: string;
}

/** Never pair a landscape poster with a different portrait edit (or vice versa). */
export function selectHomepageVideo(media: HomepageVideoSources, portrait: boolean) {
  const usePortrait = Boolean(media.portraitVideoUrl && (portrait || !media.videoUrl));
  return usePortrait
    ? { src: media.portraitVideoUrl!, poster: media.portraitVideoPoster || '' }
    : { src: media.videoUrl, poster: media.videoPoster || '' };
}
